<template>
  <div>It's time for you to verify.</div>
</template>

<script>
export default {
  name: "VerifyPage",
};
</script>

<style scoped>
</style>